import { useForm, ValidationError } from "@formspree/react";
import { useEffect, useState } from "react";
import "./ContactForm.scss";

export const ContactForm = () => {
    const [state, handleSubmit] = useForm(process.env.REACT_APP_API_KEY_FORMSPREE);
    const [isDisabledSubmit, setIsDisabledSubmit] = useState(true);
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");

    // handlers
    const handlerEmail = (e) => setEmail(e.target.value);
    const handlerMessage = (e) => setMessage(e.target.value);

    useEffect(() => {
        const allFieldsCompleted = email.length > 0 && message.length > 0;

        if (allFieldsCompleted) {
            setIsDisabledSubmit(false)
        } else {
            setIsDisabledSubmit(true)
        }
    }, [email, message])

    if (state.submitting) return <p>Sending you great message...</p>
    if (state.succeeded) return <p>Thanks for your message!</p>

    return (
        <form className="contactform" onSubmit={handleSubmit}>
            <div className="contactform__inputgroup">
                <label
                    htmlFor="email"
                    className="contactform__label"
                >Email Address</label>
                <input
                    id="email"
                    className="contactform__input"
                    type="email"
                    name="email"
                    placeholder="Write your email here"
                    maxLength="30"
                    required
                    onChange={handlerEmail}
                />
                <ValidationError
                    prefix="Email"
                    field="email"
                    errors={state.errors}
                />
            </div>
            <div className="contactform__inputgroup">
                <label
                    htmlFor="message"
                    className="contactform__label"
                >Message</label>
                <textarea
                    id="message"
                    className="contactform__textarea"
                    name="message"
                    placeholder="Write your message here"
                    maxLength="280"
                    required
                    onChange={handlerMessage}
                />
                <ValidationError
                    prefix="Message"
                    field="message"
                    errors={state.errors}
                />
            </div>
            <button
                type="submit"
                className="contactform__button"
                disabled={state.submitting || isDisabledSubmit}
            >
                SUBMIT
            </button>
        </form>
    );
}